import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_monaco_editor = _resolveComponent("monaco-editor")!
  const _component_RichEditor = _resolveComponent("RichEditor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `${_ctx.operationType=='preview'? '查看' : _ctx.operationType=='add'?'新增':'编辑'}参数`,
    modelValue: _ctx.selfVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selfVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-medium el-dialog-inner-scroll",
    center: "",
    onClose: _ctx.handleClose,
    onOpen: _ctx.handleOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.operationType !== 'preview']
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-width": "100px",
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "参数名称：",
            prop: "paramName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.paramName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.paramName) = $event)),
                modelModifiers: { trim: true },
                disabled: _ctx.operationType === 'preview'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "参数编码：",
            prop: "paramCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.paramCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.paramCode) = $event)),
                modelModifiers: { trim: true },
                disabled: _ctx.operationType !=='add'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "参数描述：",
            prop: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.description) = $event)),
                modelModifiers: { trim: true },
                disabled: _ctx.operationType === 'preview'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "数据类型：",
            prop: "dataType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.dataType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.dataType) = $event)),
                disabled: _ctx.operationType !== 'add',
                placeholder: "请选择数据数据类型",
                style: {"display":"flex","gap":"20px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DICTIONARY_STATUS_LIST, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "参数值：",
            prop: "paramValue"
          }, {
            default: _withCtx(() => [
              (_ctx.formData.dataType === _ctx.DICTIONARY_STATUS_ENUM.STRING)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    type: "textarea",
                    resize: "vertical",
                    rows: 6,
                    modelValue: _ctx.formData.paramValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.paramValue) = $event)),
                    modelModifiers: { trim: true },
                    disabled: _ctx.operationType === 'preview'
                  }, null, 8, ["modelValue", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.formData.dataType === _ctx.DICTIONARY_STATUS_ENUM.NUMBER)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    modelValue: _ctx.formData.paramValue,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.paramValue) = $event)),
                    modelModifiers: { trim: true },
                    disabled: _ctx.operationType === 'preview'
                  }, null, 8, ["modelValue", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.formData.dataType === _ctx.DICTIONARY_STATUS_ENUM.BOOLEAN)
                ? (_openBlock(), _createBlock(_component_el_radio_group, {
                    key: 2,
                    modelValue: _ctx.formData.paramValue,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.paramValue) = $event)),
                    disabled: _ctx.operationType === 'preview'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 'true' }, {
                        default: _withCtx(() => [
                          _createTextVNode("true")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 'false' }, {
                        default: _withCtx(() => [
                          _createTextVNode("false")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.formData.dataType === _ctx.DICTIONARY_STATUS_ENUM.JSON)
                ? (_openBlock(), _createBlock(_component_monaco_editor, {
                    key: 3,
                    modelValue: _ctx.formData.paramValue,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.paramValue) = $event)),
                    readonly: _ctx.operationType === 'preview',
                    style: {"height":"500px","width":"700px"}
                  }, null, 8, ["modelValue", "readonly"]))
                : _createCommentVNode("", true),
              (_ctx.formData.dataType === _ctx.DICTIONARY_STATUS_ENUM.HTML)
                ? (_openBlock(), _createBlock(_component_RichEditor, {
                    key: 4,
                    modelValue: _ctx.formData.paramValue,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.paramValue) = $event)),
                    readonly: _ctx.operationType === 'preview',
                    class: "agreement-manage__rich-editor"
                  }, null, 8, ["modelValue", "readonly"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose", "onOpen"]))
}